import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { EventDetails, EventUploadUrlData, UpdateEventPayload } from '../types';

export function useEventDetails(eventId: string) {
  const queryClient = useQueryClient();

  const { data: uploadUrlData, refetch: refetchUploadUrl } =
    useApiQuery<EventUploadUrlData>(`/events/reupload-url/${eventId}`, {
      queryKey: ['eventDetailsUploadUrl'],
      initialData: null,
    });

  const { data: uploadIdleStateUrlData, refetch: refetchIdleStateUploadUrl } =
    useApiQuery<EventUploadUrlData>(
      `/events/idle-state-video-reupload-url/${eventId}`,
      {
        queryKey: ['eventDetailsIdleStateUploadUrl'],
        initialData: null,
      }
    );

  const eventQuery = useApiQuery<EventDetails>(`/events/${eventId}`, {
    queryKey: ['eventDetails', String(eventId)],
    initialData: null,
  });

  const updateEventMutation = useApiMutation<UpdateEventPayload>(
    '/events',
    {
      method: 'PATCH',
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['eventDetails', String(eventId)],
        });
      },
      onError: (error) => {
        toast.error(
          `Uh oh! Something went wrong. ${error?.message?.slice(0, 50)}`
        );
      },
    }
  );

  return {
    eventQuery,
    updateEventMutation,
    refetchUploadUrl,
    uploadUrlData: {
      ...uploadUrlData,
      idleStateVideoPublicUrl: uploadIdleStateUrlData?.signedUrl,
    },
    refetchIdleStateUploadUrl,
  } as const;
}
